import styled from 'styled-components';
import ReactPlayer from 'react-player/lazy';
import { useCallback, useEffect, useState } from 'react';

function VideoModal({ url, show, onShowModal, videoWidth, videoHeight }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(show);
    }, [show]);

    const setOpenVideo = useCallback(
        openVideo => {
            onShowModal && onShowModal(openVideo);
        },
        [onShowModal]
    );

    return (
        <Overlay isVisible={isVisible} onClick={() => setOpenVideo(false)} className="player_dynad_tv">
            <ReactPlayer
                className="player"
                width={videoWidth ?? '800px'}
                height={videoHeight ?? '500px'}
                controls
                url={url}
            />
        </Overlay>
    );
}

export const Overlay = styled.div`
    z-index: 11;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: visible;

    @media (max-width: 800px) {
        > div {
            width: 95% !important;
            height: 350px !important;
        }
    }
`;

export default VideoModal;
